import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getCustomersByTenantId } from "../store/customers/thunks";
import { selectCustomersState } from "../store/customers/selectors";

export const useTenantCustomers = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { customersByTenants, loading } = useSelector(selectCustomersState);

  useEffect(() => {
    if (selectedTenantId && !customersByTenants?.[selectedTenantId]) {
      dispatch(
        getCustomersByTenantId({
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, customersByTenants]);

  const customers = useMemo(() => {
    return customersByTenants[selectedTenantId] || [];
  }, [customersByTenants, selectedTenantId]);

  return { customers, loading, selectedTenantId };
};
